import { Component, Inject, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { AuthStore } from 'src/app/store/auth.store';
import { formatDecimals, getInitials, withDecimals } from 'src/app/utils/utils';
import { AvatarComponent } from '../../../components/avatar/avatar.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-share-qr-sheet',
  template: `
    <svg
      class="absolute top-0 right-0 transform rotate-180"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1155 944"
      fill="none"
    >
      <g filter="url(#filter0_f_3_766)">
        <circle
          cx="179.5"
          cy="975.5"
          r="441.5"
          transform="rotate(-31.4037 179.5 975.5)"
          fill="url(#paint0_linear_3_766)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_3_766"
          x="-795.064"
          y="0.936462"
          width="1949.13"
          height="1949.13"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="266.5" result="effect1_foregroundBlur_3_766" />
        </filter>
        <linearGradient
          id="paint0_linear_3_766"
          x1="179.5"
          y1="534"
          x2="179.5"
          y2="1417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3AFF98" />
          <stop offset="1" stop-color="#00FF79" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
    <div class=" flex relative flex-col items-center">
      <div class="p-2  bg-green-50 rounded-full flex items-center mt-4 justify-center w-min">
        <svg
          class="text-green-500"
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="60"
          viewBox="0 0 24 24"
        >
          <!-- Icon from All by undefined - undefined -->
          <path
            fill="currentColor"
            d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12c0 1.6.376 3.112 1.043 4.453c.178.356.237.763.134 1.148l-.595 2.226a1.3 1.3 0 0 0 1.591 1.592l2.226-.596a1.63 1.63 0 0 1 1.149.133A9.96 9.96 0 0 0 12 22"
            opacity=".5"
          />
          <path
            fill="currentColor"
            d="M12.75 8a.75.75 0 0 0-1.5 0v.01c-1.089.275-2 1.133-2 2.323c0 1.457 1.365 2.417 2.75 2.417c.824 0 1.25.533 1.25.917s-.426.916-1.25.916s-1.25-.532-1.25-.916a.75.75 0 0 0-1.5 0c0 1.19.911 2.049 2 2.323V16a.75.75 0 0 0 1.5 0v-.01c1.089-.274 2-1.133 2-2.323c0-1.457-1.365-2.417-2.75-2.417c-.824 0-1.25-.533-1.25-.917s.426-.916 1.25-.916s1.25.532 1.25.916a.75.75 0 0 0 1.5 0c0-1.19-.911-2.048-2-2.323z"
          />
        </svg>
      </div>

      <div class="flex items-center justify-center my-3">
        <h3 class="text-lg font-bold">Pago recibido</h3>
      </div>
      <h3 class="text-3xl text-green-600 font-bold">
        {{ formatAmount(data.amount) }} {{ data.targetAccountCurrencyCode }}
      </h3>
      <div class="flex items-center flex-col my-5 text-center flex-center">
        <h1>Has recibido un pago de:</h1>

        <div class="flex flex-row mt-5">
          <app-avatar
            [size]="52"
            [initials]="getInitials(data.fromCustomer?.fullName)"
          ></app-avatar>
          <div class="flex flex-col items-start ml-3">
            <h1 class="mb-0 text-lg font-bold">{{ data.fromCustomer?.fullName }}</h1>
            <!-- <small class="mb-0 text-sm">{{ data.fromCustomer?.email }}</small> -->
            <h3 class="mt-0">{{ data.sourceAccountNumber }}</h3>
          </div>
        </div>
      </div>

      <div *ngIf="data.concept">
        <p class="text-center text-sm text-gray-500 mb-1">Concepto:</p>
        <p class="text-center text-base font-medium mb-3">{{ data.concept }}</p>
      </div>

      <!-- <div class="">
        <p class="text-center text-sm text-gray-500 mb-1">Cuenta destino:</p>
        <p class="text-center text-base font-medium mb-3">{{ data.accountNumber }}</p>
      </div> -->

      <div class="mx-auto w-full sm:w-1/2 my-5 px-5 sm:px-0">
        <button mat-flat-button class="w-full" (click)="closeSheet()">Cerrar</button>
      </div>
    </div>
  `,
  imports: [AvatarComponent, MatButtonModule, CommonModule],
  standalone: true
})
export class PaymentReceivedSheetComponent {
  getInitials = getInitials;
  authStore = inject(AuthStore);
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: PaymentReceivedData,
    private bottomSheetRef: MatBottomSheetRef<PaymentReceivedSheetComponent>
  ) {}

  closeSheet() {
    this.bottomSheetRef.dismiss();
  }

  formatAmount(amount) {
    return withDecimals(amount);
  }
}
export interface PaymentReceivedData {
  transactionCode: string;
  amount: number;
  timestamp: string;
  concept: string;
  accountNumber: string;
  targetAccountCurrencyCode: string;
  sourceAccountNumber: string;
  fromCustomer: {
    // email: string;
    fullName: string;
  };
}
